import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'opportunities',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      const opportunitiesComponent = require('./containers/OpportunitiesContainer').default;
      const {loadOpportunitiesReducer} = require('./modules/Opportunities');
      const {loadBrandNamesReducer} = require('../SalesAnalytics/modules/salesAnalytics')

      injectReducer(store, {key: 'opportunities', reducer: loadOpportunitiesReducer});
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})

      /*  Return getComponent   */
      callback(null, opportunitiesComponent)

      /* Webpack named bundle   */
    }, 'Opportunities')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Opportunities/index.js